/**
 * @module shared/common-api
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const REFERENCE_LIST_TYPES = ['customer', 'order', 'market', 'fraudRoutingReasons'];

export const FIELD_VALIDATIONS_CONSTANTS = {
  VALIDATE_SIM: 'validate-sim',
  BIRTH_DATE: 'date-of-birth',
  TMO_ACCOUNT_NUMBER: 't-mo-account-number',
  TRANSFER_ACCOUNT_NUMBER: 'osp-account-number',
  PHONE_NUMBER: 'phone-number',
  FORMATTED_PHONE_NUMBER: 'formatted-phone-number',
  REASON_CODE: 'reason-code',
  SITUATION_CODE: 'situation-code',
  SUSPECT_NUMBER: 'number-of-suspect-products',
  FULL_NAME: 'full-name',
  FIRST_NAME: 'first-name',
  MIDDLE_INITIAL: 'middle-initial',
  MIDDLE_NAME: 'middle-name',
  LAST_INITIAL: 'last-initial',
  LAST_NAME: 'last-name',
  ADDRESS_LINE1: 'address-line-1',
  ADDRESS_LINE2: 'address-line-2',
  ADDRESS: 'address-line-1',
  STATE_CODE: 'state-code',
  STATE: 'state',
  ZIP: 'zip-code',
  ZIP_CODE: 'zip-code',
  ZIP_AREA_CODE: 'zip-area-code',
  CITY: 'city',
  EMAIL_ADDRESS: 'email-address',
  COMMENT: 'comment',
  COMMENT_MANDATORY: 'comment-mandatory',
  URBANISATION: 'urbanisation',
  URB_EDIF_COND: 'urb_edif_cond',
  DATE_SINGLE: 'date-single',
  NTID: 'nt-id',
  USERNAME: 'User-name',
  PASSWORD: 't-mo-id-password',
  IMEI: 'imei-number',
  IMEI_SCANDIT: 'imei',
  IMEI_LAST_FOUR: 'imei-last-4-digits',
  IMEI_FORMAT: 'imei-numberFormatted',
  SIM: 'sim-number',
  SIM_SCANDIT: 'sim',
  SECURITY_ANSWERS: 'security-answers',
  SIM_ICCID_CSNID: 'sim-iccid-csnid-number',
  EID: 'eid',
  TMO_PIN: 't-mo-id-pin',
  PIN: 'four-digit-pin',
  USER_PIN_UPDATE: 'user-pin-update-digit',
  TMO_PASSWORD: 't-mo-id-password',
  SEARCH: 'search',
  DATE_RANGE_START: 'date-range-start',
  DATE_RANGE_END: 'date-range-end',
  DAYS: 'days',
  DOLLAR_AMOUNT: 'dollar-amount',
  LINE_NICKNAME: 'line-nickname',
  SKU: 'sku',
  UPC: 'upca',
  TSKU: 'tsku',
  SSN_LAST4: 'ssn-last-4',
  SSN_FULL: 'ssn-full',
  STOREID: 'store-location-id',
  CHECK_NUMBER: 'check-number',
  STORE_NUMBER: 'store-number',
  PROMO_CODE: 'promo-code-id',
  SSN: 'ssn-full',
  GOVERNMENTID: 'government-name-/-id',
  DEALER_CODE: 'dealer-code',
  CREDIT_CARD_NUMBER: 'credit-card-number',
  Order_ID: 'order-/-transaction-/-receipt-id',
  Tracking_Number: 'order-tracking-number',
  RMA: 'rma',
  CVV: 'ccv',
  CREDICT_CARD_NUMBER: 'credit-card-number',
  ID_NUMBER: 'id-number',
  OSP_PASSWORD_PIN: 'osp-password-pin',
  REFILL_PIN_OR_SERIAL_NUMBER: 'refill-pin-or-serial-number',
  CREDIT_CARD_NUMBER_LASTFOUR: 'credit-card-last-4',
  TOKEN_CODE: 'token-code',
  PASSCODE: 'passcode',
  NOTES_OPTIONAL: 'Notes (optional)',
  FEEDBACK_DESC: 'feedback-description',
  CARD_NUMBER_LAST_FOUR: 'card-number-last-4',
  URBANIZATION: 'urbanization',
  LICENSE_PLATE: 'license-plate',
  MAN_USERID: 'userId',
  MAN_PASSWORD: 'password',
  US_POSTAL_CODE: 'us-postal-code',
  UK_POSTAL_CODE: 'uk-postal-code',
  CANADA_POSTAL_CODE: 'canada-postal-code',
  OTHER_POSTAL_Code: 'other-postal-code',
  AUTH_Code: 'authorization-code',
  FORMATTED_AMOUNT: 'formatted-amount',
  ACTIVATION_PIN_DIGITS: 'activation-pin-digits',
  DOB: 'dob',
  SSN_OR_TRB: 'ssnOrTb',
  NVAI: 'nvai',
  EBB_MIDDLE_NAME: 'ebb-middle-name',
  T_Mobile_Phone_Number: 'T-Mobile Phone # (10 digits)',
  LAST_FOUR_CREDIT_CARD: 'last-4-credit-card',
  SIM_ESIM: 'sim-esim-number',
  ONE_TIME_PIN: 'one-time-pin',
  BILLING_PPU_ZIP: 'billing-ppu-zip',
  ZIP_CODE_REQUIRED: 'zip-code-required',
  BIRTH_MONTH_YEAR: 'birth-date',
  TMO_SIM_CARD_NUMBER: 't-mo-sim-card-number',
  ACCOUNT_PIN: 'account-pin',
  YES: 'YES',
  NO: 'NO'
};
export const COMMON_API_SERVICE_MODULE_COMPONENTS = {
  COMMON_API_SERVICE_MODULE_NAME: 'Common API Service Module',
  COMMON_API_SERVICE: 'CommonApiService',
};

export const CONSTANT_COUNTRY_CODES = {
  USA: 'USA',
};
